import * as Factory from 'factory.ts'
import faker from 'faker'

import { type UnitType } from '../../models'

export const UnitTypeMock = Factory.Sync.makeFactory<UnitType>({
  id: Factory.each(() => faker.random.number()),
  name: faker.random.word(),
  active: true,
})
